import { SiteNav } from './SiteNav';

/**
 * The shared hero band: the wordmark + pill navbar sitting over the particle
 * field. Used by every page except the logo page.
 */
export function SiteHeader({ plain = false }: { plain?: boolean }) {
  const header = (
    <>
      <h1 className="site-title">Tyler Wrenn</h1>
      <SiteNav />
    </>
  );

  if (plain) {
    return header;
  }

  return (
    <div className="jumbotron-constrain d-block">
      <div className="container text-center py-5">{header}</div>
    </div>
  );
}
